import { useCallback } from 'react';

import {
  EcommerceSectionNamespace,
  TEcommerceItem,
  trackAddToCartEvent,
  trackRemoveFromCartEvent,
} from '@services/ecommerceService';

export const useTrackModifyCartEvent = () => {
  return useCallback(
    ({
      action,
      product,
      quantity,
    }: {
      action: EcommerceSectionNamespace.EEcommerceCartActions;
      product: TEcommerceItem;
      quantity: number;
    }) => {
      switch (action) {
        case EcommerceSectionNamespace.EEcommerceCartActions.ADD:
          trackAddToCartEvent(product, quantity);
          break;
        case EcommerceSectionNamespace.EEcommerceCartActions.REMOVE:
          trackRemoveFromCartEvent(product, quantity);
          break;
      }
    },
    [],
  );
};
